import { createComponent } from '@helpers/admin';
import CardsSectionComponent from '@template/blocks/CardsSection/component';

export const Cards = createComponent({
  label: 'Cards',
  component: CardsSectionComponent,
  fields: {
    title: {
      label: 'Title',
      type: 'textarea',
    },
    description: {
      label: 'Description',
      type: 'textarea',
    },
    cards: {
      label: 'Cards',
      type: 'array',
      arrayFields: {
        title: {
          label: 'Title',
          type: 'textarea',
        },
        description: {
          label: 'Description',
          type: 'textarea',
        },
        spanText: {
          label: 'Span Text',
          type: 'text',
        },
        image: {
          label: 'Image',
          type: 'image',
        },
        cta: {
          label: 'CTA',
          type: 'object',
          objectFields: {
            label: {
              label: 'Label',
              type: 'textarea',
            },
            href: {
              label: 'Link',
              type: 'textarea',
            },
          },
        },
      },
    },
    inverted: {
      label: 'Grey Background',
      type: 'boolean',
    },
    altStyling: {
      label: 'Alternative Styling',
      type: 'boolean',
    },
    numbered: {
      label: 'Numbered',
      type: 'boolean',
    },
  },
});
